$(document).ready(function ($) {
    // footer dropdown menu for tablet
    let canClick = true;

    function initFooterDropdown() {
        const isMobile = $(window).width() <= 1023;
        const $links = $(".wrap-footer-items ul li > a");

        $links.off("click.footerDropdown");

        if (!isMobile || !$(".wrap-footer-items").length) {
            return;
        }

        $links.on("click.footerDropdown", function (e) {
            const $this = $(this);
            const $parentLi = $this.parent("li");
            const $submenu = $parentLi.children("ul");

            // Let regular links work normally
            if (!$submenu.length) {
                return;
            }

            e.preventDefault();

            if (!canClick) {
                return;
            }

            canClick = false;

            if ($this.hasClass("active")) {
                $this.removeClass("active");
                $parentLi.removeClass("active");
                $submenu.stop(true, true).slideUp();
            } else {
                $this.addClass("active");
                $parentLi.addClass("active");
                $submenu.stop(true, true).slideDown();
            }

            setTimeout(() => {
                canClick = true;
            }, 500);
        });
    }

    initFooterDropdown();
    $(window).on("resize", initFooterDropdown);

    // footer animation
    function isInViewport(element) {
        const elementTop = $(element).offset().top;
        const elementBottom = elementTop + $(element).outerHeight();
        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop + 50 && elementTop < viewportBottom;
    }

    function checkFooterVisibility() {
        const footer = $("footer");
        if (isInViewport(footer)) {
            footer.addClass("visible");
        } else {
            footer.removeClass("visible");
        }
    }

    $(window).on("scroll resize load", checkFooterVisibility);
});